import React, { useEffect } from 'react';
import './manager-element-list-menu.styles.scss';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faTrash } from '@fortawesome/free-solid-svg-icons';
import { sortElementsNoThe } from '@/utils/sortElements';

const ManagerElementListMenu = ({
    gameElements,
    elementsFromDb,
    type,
    itemType,
    setContentToDisplay,
    setDropdown,
    setSelectedCategories,
    setFilteredElements,
    setCategoryList,
    setTypeList,
    menuCategory,
    setMenuCategory, 
    catRef
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);

    useEffect(() => {
        if (!elementsFromDb) return;
        setDropdown(null);
        setContentToDisplay([]);
        if (catRef) catRef.current = [];
        if (setSelectedCategories) setSelectedCategories(catRef.current)
        const filtered = Object.values(elementsFromDb)
        .filter(a => 
            a.type === type && 
            (
                (
                    itemType && 
                    a.opt_itemType === itemType
                ) || !itemType
            ) &&
            ((menuCategory === 'visible')
            ? a.opt_visible && a.status === 'active'
            : (menuCategory === 'invisible')
            ? !a.opt_visible && a.status === 'active'
            : (menuCategory === 'deleted')
            ? a.status === 'inactive'
            : false)
        )
        setFilteredElements(sortElementsNoThe(filtered))
        // create new Set of categories to avoid duplicates,
        // then sort alphabetically ignoring "The " at the beginning
        if (setCategoryList) setCategoryList(
            [...new Set(filtered.filter(c => c.opt_cat).map(c => c.opt_cat))]
            .sort((a,b) => a.toLowerCase().replace('The ', '') - b.toLowerCase().replace('The ', ''))
        );
        if (setTypeList) setTypeList([...new Set(filtered.filter(c => c.opt_itemType).map(c => c.opt_itemType))])
    }, [elementsFromDb, menuCategory])

    return (
        <div className={`manager-element-list-menu ${screenSize}`}>
            <button
                className={`g-button ${
                    menuCategory === 'visible' 
                    ? 'primary' 
                    : ''
                } ${
                    screenSize === 'mobile'
                    ? 'small-btn'
                    : 'med-btn'
                }`}
                onClick={() => setMenuCategory('visible')} >
                {
                    (screenSize === 'mobile')
                    ? ''
                    : 
                    <FontAwesomeIcon
                        icon={faEye} /> 
                }
                    Visible
            </button>
            <button
                className={`g-button ${
                    menuCategory === 'invisible' 
                    ? 'primary' 
                    : ''
                } ${
                    screenSize === 'mobile'
                    ? 'small-btn'
                    : 'med-btn'
                }`}
                onClick={() => setMenuCategory('invisible')} >
                {
                    (screenSize === 'mobile')
                    ? ''
                    :
                    <FontAwesomeIcon
                        icon={faEyeSlash} /> 
                }
                Hidden
                
            </button>
            <button
                className={`g-button ${
                    menuCategory === 'deleted' 
                    ? 'primary' 
                    : ''
                } ${
                    screenSize === 'mobile'
                    ? 'small-btn'
                    : 'med-btn'
                }`}
                onClick={() => setMenuCategory('deleted')} >
                {
                    (screenSize === 'mobile')
                    ? ''
                    :
                    <FontAwesomeIcon
                        icon={faTrash} /> 
                }
                Deleted
                
            </button>
        </div>
    )
}

export default ManagerElementListMenu